export default __webpack_public_path__ + "static/media/caen2.5c5ae1aa.jpg";